import { LegalLayout, Section, Li, B } from "../components/LegalLayout";

const UPDATED = "June 1, 2026";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy" updated={UPDATED}>
      <p className="text-slate-300">
        This Privacy Policy explains how PNR Decode ("we", "us", "our") collects, uses, shares and protects your
        personal information when you use our website and services. By using PNR Decode you agree to this policy.
      </p>

      <Section heading="1. Information We Collect">
        <ul className="space-y-2">
          <Li><b>Account data:</b> your name and email address when you create an account.</Li>
          <Li><b>Payment information:</b> billing details and card metadata (e.g. card brand and last four digits) processed for subscriptions. Full card numbers are handled by our payment processor and are not stored on our servers.</Li>
          <Li><b>Usage data:</b> itineraries you convert, layouts and branding you configure, API usage, log-in timestamps, IP address, browser and device information.</Li>
          <Li><b>Communications:</b> messages you send us via the contact form or by email.</Li>
        </ul>
      </Section>

      <Section heading="2. How We Use Your Information">
        <ul className="space-y-2">
          <Li>To provide, operate and maintain the service, including converting and rendering itineraries.</Li>
          <Li>To authenticate you, secure your account and prevent fraud or abuse.</Li>
          <Li>To process subscriptions, send transactional emails (verification codes, receipts) and provide support.</Li>
          <Li>To improve our features, monitor performance and understand how the service is used.</Li>
          <Li>To comply with legal obligations.</Li>
        </ul>
      </Section>

      <Section heading="3. How We Share Information">
        <p>We do not sell your personal data. We share it only with:</p>
        <ul className="space-y-2">
          <Li><b>Service providers</b> that help us operate (hosting, email delivery, payment processing, analytics), bound by confidentiality obligations.</Li>
          <Li><b>Authorities</b> where required by law, regulation or valid legal process.</Li>
          <Li><b>Successors</b> in the event of a merger, acquisition or asset sale, subject to this policy.</Li>
        </ul>
      </Section>

      <Section heading="4. Data Retention">
        <p>
          We keep your account and usage data for as long as your account is active. Billing and transaction
          records are retained for up to 7 years to meet accounting and legal requirements. If you delete your
          account, we remove or anonymise your personal data within 30 days, except where longer retention is
          legally required.
        </p>
      </Section>

      <Section heading="5. Your Rights">
        <p>Depending on your location, you may have the right to:</p>
        <ul className="space-y-2">
          <Li><b>Access</b> the personal data we hold about you.</Li>
          <Li><b>Correct</b> inaccurate or incomplete data.</Li>
          <Li><b>Delete</b> your data ("right to be forgotten").</Li>
          <Li><b>Object to or restrict</b> certain processing, and request data portability.</Li>
        </ul>
        <p>To exercise any of these rights, contact us at support@pnrdecode.com.</p>
      </Section>

      <Section heading="6. Security">
        <p>
          We use industry-standard measures — encryption in transit, hashed passwords, optional two-factor
          authentication and access controls — to protect your data. No method of transmission or storage is
          100% secure, but we work hard to safeguard your information.
        </p>
      </Section>

      <Section heading="7. Contact">
        <p>For any privacy-related queries or requests, email <B>support@pnrdecode.com</B>.</p>
      </Section>
    </LegalLayout>
  );
}
